module.exports = __webpack_public_path__ + "img/20220628102228327h0q.f7b9881f.jpg";